import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AkaConsent, ConsentState } from "./consentInterfaces";

const initialState: ConsentState = {
  consented: undefined,
  isUpdating: false,
  updated: false,
  error: null,
};

const akaConsentSlice = createSlice({
  name: "akaConsent",
  initialState,
  reducers: {
    setAkaConsentFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload?.toString();
      state.isUpdating = false;
    },

    getAkaConsent: (state) => {
      state.isUpdating = true;
    },

    setAkaConsent: (state, action: PayloadAction<AkaConsent>) => {
      state.consented = action.payload.consented;
      state.isUpdating = true;
    },

    setAkaConsentSucceeded: (state) => {
      state.isUpdating = false;
      state.updated = true;
      state.error = null;
    },
  },
});

export const {
  setAkaConsentFailed,
  getAkaConsent,
  setAkaConsent,
  setAkaConsentSucceeded,
} = akaConsentSlice.actions;

export const akaConsent = akaConsentSlice.reducer;
